<template>
  <v-list class="pa-0 pm-0" v-if="current_user != null">
    <template v-for="(item, key) in items">
      <v-list-group
        class="pa-0 pm-0"
        v-if="
          hasChild(item) &&
          (item.restricted == null ||
            item.restricted.includes(current_user.role))
        "
        :key="key"
        no-action
        :to="item.path"
        :value="computeGroupExpanded(item, $route)"
      >
        <template #prependIcon class="ma-0">
          <v-tooltip bottom class="ma-0">
            <template #activator="{ on, attrs }" class="ma-0">
              <v-icon
                v-if="item.icon"
                v-bind="attrs"
                v-on="on"
                v-text="item.icon"
                class="ma-0"
              />
              <v-img :src="item.img" :width="40" v-if="item.img" />
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>
        </template>
        <template #activator>
          <v-list-item-content>
            <v-list-item-title class="text-wrap">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
        <nav-list-item
          v-for="child in item.children"
          v-show="!mini"
          :key="'c' + child.path"
          :item="child"
        />
      </v-list-group>
      <span v-else :key="'nav' + key">
        {{ item.meta }}
        <nav-list-item
          :item="item"
          v-if="
            item.restricted == null ||
            item.restricted.includes(current_user.role)
          "
      /></span>
    </template>
  </v-list>
</template>

<script>
import NavListItem from "./NavListItem"
export default {
  components: {
    NavListItem,
  },
  props: {
    mini: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
  },
  methods: {
    hasChild(item) {
      return Array.isArray(item.children) && item.children.length > 0
    },
    computeGroupExpanded(item, $route) {
      return $route.matched.map((item) => item.path).includes(item.path)
    },
  },
}
</script>
<style>
.v-list-item__icon {
  margin-right: 5px !important;
}
</style>
